import React, { useEffect, useRef, useState } from "react";
import Player from "./Player";
import store from "@/stores/clipEditor/player";
import trackStore from "@/stores/clipEditor/trackState";
import { observer } from "mobx-react";

const PlayerContainer: React.FC = () => {
  const playerContent = useRef<HTMLDivElement>(null);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

  // 取消选中
  const cancelSelect = (event: React.MouseEvent) => {
    event.stopPropagation();
    trackStore.setSelectTrackItem({ line: -1, index: -1 });
  };

  // 更新画布尺寸
  const updateContainerSize = () => {
    if (!playerContent.current) return;
    const { width, height } = playerContent.current.getBoundingClientRect();
    setContainerSize({ width, height });
  };

  // 组件挂载时初始化尺寸
  useEffect(() => {
    updateContainerSize();
  }, []);

  // 监听窗口大小变化
  useEffect(() => {
    window.addEventListener("resize", updateContainerSize);
    return () => {
      window.removeEventListener("resize", updateContainerSize);
    };
  }, []);

  // 监听 trackHeight 变化
  //   useEffect(() => {
  //     updateContainerSize();
  //   }, [pageStore.trackHeight]);

  // 监听 playerHeight 和 playerWidth 变化
  useEffect(() => {
    updateContainerSize();
  }, [store.playerConfig.playerHeight, store.playerConfig.playerWidth]);

  return (
    <div
      className="flex-1 overflow-hidden relative"
      style={{
        flex: 1,
        overflow: "hidden",
        position: "relative",
        height: "100%",
      }}
      ref={playerContent}
      onClick={cancelSelect}
    >
      <Player containerSize={containerSize} />
    </div>
  );
};

export default observer(PlayerContainer);
